'use strict';
import { environment } from '@environments/environment';

angular.module('schoolLinqApp').factory('authInterceptorService', [
	'$q',
	'$location',
	'apiVersionService',
	'authService',
	function ($q, $location, apiVersionService, authService) {
		let authInterceptorServiceFactory = {};

		var _getAuthToken = function () {
			return authService.accessToken;
		};

		var _getBearerToken = function () {
			let token = authService.accessToken;
			if (token) {
				token = 'Bearer ' + token;
			}

			return token;
		};

		var _request = function (config) {
			// Don't modify the request URL for OIDC authority requests, otherwise they will fail.
			if (config.url.startsWith(environment.OIDC_AUTHORITY)) {
				return config;
			}

			config.headers = config.headers || {};

			// Only prepend API_URL for relative URLs (our API), not absolute URLs (OIDC endpoints)
			if ((config.url.indexOf('api/') >= 0 || config.url.indexOf('token') >= 0) && !config.url.startsWith('http')) {
				config.url = environment.API_URL + config.url;
			}

			const authData = authService.accessToken;
			if (authData) {
				config.headers.Authorization = 'Bearer ' + authData;
			}

			return config;
		};

		var _response = function (result) {
			const responseApiVersion = result.headers('x-api-version');
			apiVersionService.checkApiVersion(responseApiVersion);
			return result;
		};

		var _responseError = function (rejection) {
			if (rejection.status === 401) {
				const loginPath = authService.getLoginPath();
				$location.path(loginPath);
			}
			return $q.reject(rejection);
		};

		authInterceptorServiceFactory.request = _request;
		authInterceptorServiceFactory.responseError = _responseError;
		authInterceptorServiceFactory.response = _response;
		authInterceptorServiceFactory.authToken = _getAuthToken;
		authInterceptorServiceFactory.bearerToken =_getBearerToken;

		return authInterceptorServiceFactory;
	},
]);
